import { render, staticRenderFns } from "./CustomFieldRadio.vue?vue&type=template&id=9f8f2122&scoped=true"
import script from "./CustomFieldRadio.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomFieldRadio.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CustomFieldRadio.vue?vue&type=style&index=0&id=9f8f2122&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8f2122",
  null
  
)

export default component.exports